import { z } from 'zod';

import constants from '../../constants';
import { SORT_DIRECTION } from '../profiles/location/types';
import { RESTORE_POINT_TYPES, RESTORE_POINTS_SORT_BY } from './constants';

export const restorePointsFiltersSchema = z.object({
  appType: z
    .enum([constants.RESTORE_POINT_APP_TYPE_NAMESPACE, constants.RESTORE_POINT_APP_TYPE_VM])
    .default(constants.RESTORE_POINT_APP_TYPE_NAMESPACE),
  appRefs: z.array(z.string()).optional(),
  createdAfter: z.string().optional(),
  createdBefore: z.string().optional(),
  includeManualRunsOnly: z.boolean(),
  noExpiration: z.boolean(),
  successfulWithExceptions: z.boolean().optional(),
  policyNames: z.array(z.string()).optional(),
  profileNames: z.array(z.string()).optional(),
  types: z.enum(RESTORE_POINT_TYPES).optional(),
});

export const restorePointsRouteQueryParamsSchema = z.object({
  ...restorePointsFiltersSchema.shape,
  appType: restorePointsFiltersSchema.shape.appType.default(
    constants.RESTORE_POINT_APP_TYPE_NAMESPACE,
  ),
  includeManualRunsOnly: z.boolean().optional(),
  noExpiration: z.boolean().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
  sortBy: z.enum(RESTORE_POINTS_SORT_BY).optional(),
  sortDir: z.enum(SORT_DIRECTION).optional(),
});
